<template>
  <div
    class="rich-text-input border"
    :class="{ 'border-danger': state == false, 'border-success': state == true }"
  >
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <b-button-toolbar class="toolbar bg-light">
        <b-button-group size="sm">
          <b-button
            variant="light"
            :pressed="isActive.heading({ level: 3 })"
            @click="commands.heading({ level: 3 })"
          >
            <b-icon icon="type-h3" />
          </b-button>
          <b-button variant="light" :pressed="isActive.bold()" @click="commands.bold">
            <b-icon icon="type-bold" />
          </b-button>
        </b-button-group>
        <b-button-group size="sm">
          <b-button variant="light" :pressed="isActive.bullet_list()" @click="commands.bullet_list">
            <b-icon icon="list-ul" />
          </b-button>
          <b-button
            variant="light"
            :pressed="isActive.ordered_list()"
            @click="commands.ordered_list"
          >
            <b-icon icon="list-ol" />
          </b-button>
        </b-button-group>
      </b-button-toolbar>
    </editor-menu-bar>

    <div class="content">
      <editor-content class="editor-content" :editor="editor" />
    </div>
  </div>
</template>
<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Heading,
  Bold,
  ListItem,
  BulletList,
  OrderedList,
  History,
} from "tiptap-extensions";

export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  props: ["value", "state"],
  data() {
    return {
      editor: null,
      currentValue: null
    };
  },
  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
        new Heading({ levels: [3] }),
        new Bold(),
        new ListItem(),
        new BulletList(),
        new OrderedList(),
        new History(),
      ],
      onUpdate: (e) => {
        const json = e.getJSON();
        if (json.content.length == 1 && json.content[0].content == null)
          this.$emit("input", null);
        else this.$emit("input", e.getHTML());
      },
    });
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.currentValue == val) return;
        this.currentValue = val
        if (this.editor) this.editor.setContent(this.currentValue);
      },
    },
    editor(ed) {
      if (ed != null) ed.setContent(this.currentValue)
    }
  },
  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>
<style lang="scss" scoped>
.rich-text-input {
  width: 100%;
}

.content {
  padding: 0.5rem;

  .editor-content {
    & ::v-deep > .ProseMirror {
      outline: none;
      border: none;

      min-height: 5rem;

      h3 {
        font-size: 1.2rem;
        margin-bottom: 0.25rem;
      }
      p {
        margin-bottom: 0.5rem;
      }

      ul,
      ol {
        padding-left: 1.25rem;
      }

      li ~ li {
        margin-top: 0.1rem;
      }

      li p {
        margin: 0;
      }
    }
  }
}
</style>